export const TRANSACTION_MODE = {
  TRANSFER_IN: 7,
  TRANSFER_OUT: 13,
  PAID_IN_OUT: 15,
  POUCH_PREPARATION: 26,
  POUCH_PREPARATION_CANCEL: 27,
  DISCREPANCY_MODE: 15,
  TC_SETTLE_T0_PL: 31,
  TC_SETTLE_TO_NOMINEE: 32,
  TC_SETTLE_TO_CASH: 29,
  POUCH_ACCEPTANCE: 24,
  POUCH_DESPATCH: 28,
};

export const TRANSACTION_ITEM_ID = {
  CASH: '1',
  TRANSFER_IN: '6276',
  TRANSFER_OUT: '6277',
  PAID_IN: '247', //"6295",
  PAID_OUT: ['247', '248', '6497', '6495', '6496'], //"6295",
  POUCH_PREPARATION: '5610', //Same for Cancel Prepared Pouch
  POUCH_ACCEPTANCE: '6287',
  POUCH_DESPATCH: '6286',
  DISCREPANCY_POUCH: '50818',
  SETTLED_TO_NOMINEE: '50919',
  MULTIPLE_SETTLED: '50917',
  SETTLE_TO_ACCOUNT: '50918',
  SETTLE_TO_PL: '6292',
  //known variance discrepancy itemID
  POUCH_DESPATCH_SURPLUS: '50817',
  POUCH_DESPATCH_SHORTAGE: '50818',
  POUCH_ACCEPTANCE_SURPLUS: '50811',
  POUCH_ACCEPTANCE_SHORTAGE: '50812',
  BANKING_MISS_KEY_LOSS: '50824',
  BANKING_MISS_KEY_GAIN: '50823',
  DEBIT_CREDIT_FAILURE_LOSS: '50826',
  //known variance (TP-BP) discrepancy itemID
  TP_BP_BALANCING_SURPLUS: '50832',
  TP_BP_BALANCING_SHORTAGE: '50833',
  //TC update itemId
  TC_SETTLE: '9574',
  TC_SETTLE_TO_CASH: '50817',
  TC_SURPLUS_SETTLEMENT: '8570',
  TC_CASH_PA: '9243',
};

// ****************************
// TODO: This is copied over from the old repo and will probably end up being redone better by Reece's Denomination Ladder ticket. Delete this next section when that is in

export const PARTIAL_COIN_BAGS: Record<string, string> = {
  3336: '£2 Partial Coin Bag',
  3337: '£1 Partial Coin Bag',
  3338: '50p Partial Coin Bag',
  3339: '20p Partial Coin Bag',
  3340: '10p Partial Coin Bag',
  3341: '5p Partial Coin Bag',
  3342: '2p Partial Coin Bag',
  3343: '1p Partial Coin Bag',
};
const FULL_COIN_BAGS = {
  3328: '£2 Coin Full Bag',
  3329: '£1 Coin Full Bag',
  3330: '50p Coin Full Bag',
  3331: '20p Coin Full Bag',
  3332: '10p Coin Full Bag',
  3333: '5p Coin Full Bag',
  3334: '2p Coin Full Bag',
  3335: '1p Coin Full Bag',
};

const COMBINED_ITEM_ID = {
  356: '£100 Notes',
  655: '£50 Notes',
  656: '£20 Notes',
  657: '£10 Notes',
  658: '£5 Notes',
  659: '£1 Notes',
  357: '£2 Coins',
  660: '£1 Coins',
  661: '50p Coins',
  662: '1p Coins',
  663: '2p Coins',
  2189: '5p Coins',
  2190: '10p Coins',
  2191: '20p Coins',
};

const UNUSED_ITEM_ID = {
  3322: 'Non-Usable Note £100',
  3323: 'Non-Usable Note £50',
  3324: 'Non-Usable Note £20',
  3325: 'Non-Usable Note £10',
  3326: 'Non-Usable Note £5',
  3327: 'Non-Usable Note £1',
  3344: 'Non-Usable Coin £5',
  3345: 'Non-Usable Coin £2',
  3346: 'Non-Usable Coin £1',
  3347: 'Non-Usable Coin 50p',
  3348: 'Non-Usable Coin 20p',
  3349: 'Non-Usable Coin 10p',
  3350: 'Non-Usable Coin 5p',
  3351: 'Non-Usable Coin 2p',
  3352: 'Non-Usable Coin 1p',
  3320: 'Non-Usable Notes',
  3321: 'Non-Usable Coins',
};

export const CURRENCY_ITEM_ID_LABELS: Record<string, string> = {
  ...UNUSED_ITEM_ID,
  ...PARTIAL_COIN_BAGS,
  ...FULL_COIN_BAGS,
  ...COMBINED_ITEM_ID,
};

export const COIN_MAPPING: Record<string, number> = {
  '£2': 357,
  '£1': 660,
  '50p': 661,
  '20p': 2191,
  '10p': 2190,
  '5p': 2189,
  '2p': 663,
  '1p': 662,
};

// ****************************

export const CURRENCY_ITEM_IDS = {
  NOTE_50_POUND_ID: '655',
  NOTE_20_POUND_ID: '656',
  NOTE_10_POUND_ID: '657',
  NOTE_5_POUND_ID: '658',
  COIN_2_POUND_ID: '357',
  COIN_1_POUND_ID: '660',
  COIN_50_PENCE_ID: '661',
  COIN_20_PENCE_ID: '2191',
  COIN_10_PENCE_ID: '2190',
  COIN_5_PENCE_ID: '2189',
  COIN_2_PENCE_ID: '663',
  COIN_1_PENCE_ID: '662',
  NOTE_UNUSABLE_100_POUND_ID: '3322',
  NOTE_UNUSABLE_50_POUND_ID: '3323',
  NOTE_UNUSABLE_20_POUND_ID: '3324',
  NOTE_UNUSABLE_10_POUND_ID: '3325',
  NOTE_UNUSABLE_5_POUND_ID: '3326',
  NOTE_UNUSABLE_1_POUND_ID: '3327',
  BAG_2_POUND_FULL_ID: '3328',
  BAG_1_POUND_FULL_ID: '3329',
  BAG_50_PENCE_FULL_ID: '3330',
  BAG_20_PENCE_FULL_ID: '3331',
  BAG_10_PENCE_FULL_ID: '3332',
  BAG_5_PENCE_FULL_ID: '3333',
  BAG_2_PENCE_FULL_ID: '3334',
  BAG_1_PENCE_FULL_ID: '3335',
  BAG_2_POUND_PARTIAL_ID: '3336',
  BAG_1_POUND_PARTIAL_ID: '3337',
  BAG_50_PENCE_PARTIAL_ID: '3338',
  BAG_20_PENCE_PARTIAL_ID: '3339',
  BAG_10_PENCE_PARTIAL_ID: '3340',
  BAG_5_PENCE_PARTIAL_ID: '3341',
  BAG_2_PENCE_PARTIAL_ID: '3342',
  BAG_1_PENCE_PARTIAL_ID: '3343',
  COIN_UNUSABLE_5_POUND_ID: '3344',
  COIN_UNUSABLE_2_POUND_ID: '3345',
  COIN_UNUSABLE_1_POUND_ID: '3346',
  COIN_UNUSABLE_50_PENCE_ID: '3347',
  COIN_UNUSABLE_20_PENCE_ID: '3348',
  COIN_UNUSABLE_10_PENCE_ID: '3349',
  COIN_UNUSABLE_5_PENCE_ID: '3350',
  COIN_UNUSABLE_2_PENCE_ID: '3351',
  COIN_UNUSABLE_1_PENCE_ID: '3352',
  UNUSABLE_NOTES_ID: '3320',
  UNUSABLE_COINS_ID: '3321',
};
